(function () {
  function init(scope) {
    var root = scope.querySelector('[data-vw-compose]');
    if (!root || root.dataset.purchaseBarReady) return;
    var section = root.closest('.shopify-section');
    var pick = root.querySelector('[data-vw-pick]');
    var nativeButton = section && section.querySelector('button.add-to-cart');
    if (!section || !pick || !nativeButton) return;
    root.dataset.purchaseBarReady = 'true';

    var bar = document.createElement('aside');
    bar.className = 'vw-purchase-bar';
    bar.setAttribute('aria-label', 'Récapitulatif du pack');
    bar.hidden = true;
    var summary = document.createElement('div');
    summary.className = 'vw-purchase-bar__summary';
    var total = document.createElement('strong');
    var saving = document.createElement('span');
    summary.appendChild(total);
    summary.appendChild(saving);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'vw-purchase-bar__button';
    var label = document.createElement('span');
    var arrow = document.createElement('span');
    arrow.textContent = '→';
    arrow.setAttribute('aria-hidden', 'true');
    button.appendChild(label);
    button.appendChild(arrow);
    bar.appendChild(summary);
    bar.appendChild(button);
    document.body.appendChild(bar);

    var frame = 0;
    var releaseTimer = 0;
    var locked = false;
    var destroyed = false;

    function setText(el, value) {
      if (el.textContent !== value) el.textContent = value;
    }
    function count() { return Number(pick.getAttribute('data-count')) || 0; }
    function unavailable() {
      return !count() || pick.hidden || pick.getAttribute('aria-busy') === 'true' || nativeButton.disabled ||
        nativeButton.getAttribute('aria-disabled') === 'true' || nativeButton.getAttribute('aria-busy') === 'true' ||
        nativeButton.classList.contains('disabled--transient') || nativeButton.classList.contains('disabled--unavailable');
    }
    function update() {
      frame = 0;
      if (destroyed) return;
      if (!root.isConnected) { destroy(); return; }
      var rect = nativeButton.getBoundingClientRect();
      var area = section.getBoundingClientRect();
      var viewport = window.visualViewport;
      var bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      var show = !pick.hidden && count() > 0 && rect.height > 0 && area.top < bottom && area.bottom > 0 && rect.bottom > bottom - 8;
      var active = document.activeElement;
      if (active && active.matches('input,textarea,[contenteditable="true"]') && viewport && viewport.height < window.innerHeight * 0.75) show = false;
      if (!show && !bar.hidden && bar.contains(active) && rect.top >= 0 && rect.bottom <= bottom) nativeButton.focus({ preventScroll: true });
      if (bar.hidden === show) bar.hidden = !show;
      if (document.body.classList.contains('vw-purchase-visible') !== show) document.body.classList.toggle('vw-purchase-visible', show);
      if (!show) return;

      var sourceTotal = root.querySelector('[data-vw-pick-summary] strong');
      var sourceSaving = root.querySelector('.vw-pick__badge');
      var selectionText = count() + ' numéro' + (count() > 1 ? 's' : '');
      setText(total, selectionText + (sourceTotal ? ' · ' + sourceTotal.textContent.trim() : ''));
      setText(saving, sourceSaving ? sourceSaving.textContent.trim() : 'Votre pack');
      if (saving.classList.contains('is-saving') !== !!sourceSaving) saving.classList.toggle('is-saving', !!sourceSaving);
      var busy = locked || pick.getAttribute('aria-busy') === 'true' || nativeButton.getAttribute('aria-busy') === 'true' || nativeButton.classList.contains('disabled--transient');
      setText(label, busy ? 'Actualisation…' : nativeButton.textContent.trim().replace(/\s+/g, ' '));
      var disabled = locked || unavailable();
      if (button.disabled !== disabled) button.disabled = disabled;
      var height = Math.ceil(bar.getBoundingClientRect().height) + 'px';
      if (document.body.style.getPropertyValue('--vw-purchase-height') !== height) document.body.style.setProperty('--vw-purchase-height', height);
    }
    function schedule() { if (!frame && !destroyed) frame = window.requestAnimationFrame(update); }
    function release() {
      locked = false;
      window.clearTimeout(releaseTimer);
      schedule();
    }
    button.addEventListener('click', function () {
      if (locked || unavailable()) return;
      locked = true;
      button.disabled = true;
      setText(label, 'Actualisation…');
      releaseTimer = window.setTimeout(release, 1500);
      nativeButton.click();
      schedule();
    });
    var observer = new MutationObserver(schedule);
    observer.observe(section, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-count', 'aria-busy', 'aria-disabled', 'disabled', 'hidden', 'class'] });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('baseline:cart:afteradditem', release);
    document.addEventListener('baseline:productform:success', release);
    document.addEventListener('vw:cart', release);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule);
      window.visualViewport.addEventListener('scroll', schedule);
    }
    function unload(event) { if (event.target === section || event.target.contains(section)) destroy(); }
    function destroy() {
      destroyed = true;
      observer.disconnect();
      window.cancelAnimationFrame(frame);
      window.clearTimeout(releaseTimer);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', schedule);
      window.removeEventListener('baseline:cart:afteradditem', release);
      document.removeEventListener('baseline:productform:success', release);
      document.removeEventListener('vw:cart', release);
      document.removeEventListener('shopify:section:unload', unload);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', schedule);
        window.visualViewport.removeEventListener('scroll', schedule);
      }
      bar.remove();
      document.body.classList.remove('vw-purchase-visible');
      document.body.style.removeProperty('--vw-purchase-height');
      delete root.dataset.purchaseBarReady;
    }
    document.addEventListener('shopify:section:unload', unload);
    schedule();
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
